import React from 'react'

export default function Companies() {
    return (
        <>
            <h1>Gérer vos sociétés</h1>
        </>)
}
